import { render, staticRenderFns } from "./VariantSelector.vue?vue&type=template&id=04b8f271&scoped=true"
import script from "./VariantSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./VariantSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VariantSelector.vue?vue&type=style&index=0&id=04b8f271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8f271",
  null
  
)

export default component.exports